import axios from 'axios'
import { API_BASE_URL } from '@/config/env'

const http = axios.create({
  baseURL: API_BASE_URL || undefined,
  withCredentials: true,
  timeout: 30000,
})

export default http
